module.exports = __webpack_public_path__ + "img/bj002-002.8ede7ace.jpg";